import React from "react"
import { Link } from 'react-router-dom'
import Back from "../common/Back"
import Heading from "../common/Heading"
import img from "../images/about.jpeg"
import "./about.css"

const About = () => {
  return (
    <>
      <section className='about'>
        <Back name='Let us take care of the details, so you can focus on making memories!' title='About Us - Who Are We?' cover={img} />
       
        <div className='container flex mtop'>
          <div className='left row'>
            <Heading title='Our Story' subtitle='Check out our company story and work process' />
            <p>Meta Decor and Event Management is a professional event management company offering decor, styling and wedding planning services to individuals and the corporate market. </p>
            <p>An emerging Event Management Company that provides high-end Event Management & Event Planning for all your event needs.</p>
            <p className="bold-center">💃💃 Jane Furse Finest!💃💃</p>
            <p>We are located in Limpopo at Stand No. B0039 Dichoueng , Jane Furse, Limpopo 1085</p>
            {/* <p>Get in Touch:</p> */}

            <div class="buttons">
              <Link to={"/contact"}><i className="fa fa-book"></i> Stay in Touch</Link>
            </div>
          </div>
          <div className='right row'>
            <img src='./immio.jpeg' alt='' />
          </div>
        </div>
      </section>
    </>
  )
}

export default About
